var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMesfactures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0435 1.08698V4.47828C14.0435 5.00002 14.3913 5.34785 14.913 5.34785H18.3043",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60864 11.4348V1.86957C3.60864 1.34783 3.95647 1 4.47821 1H13.6956C13.9565 1 14.1304 1.08696 14.3043 1.26087L18.1304 5.08696C18.3043 5.26087 18.3913 5.43478 18.3913 5.69565V18.3913C18.3913 18.913 18.0434 19.2609 17.5217 19.2609H13.1739",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21729 5.34772H11.8695",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21729 5.34772H11.8695",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21729 7.95654H12.739",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21729 10.5652H15.3477",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3043 13.1739H6.21739C5.95652 13.1739 5.69565 13.0869 5.52174 12.826L4.73913 11.7825C4.56522 11.5217 4.30435 11.4347 4.04348 11.4347H1.86957C1.34783 11.4347 1 11.7825 1 12.3043V20.1304C1 20.6521 1.34783 20.9999 1.86957 20.9999H12.3043C12.8261 20.9999 13.1739 20.6521 13.1739 20.1304V14.0434C13.1739 13.5217 12.8261 13.1739 12.3043 13.1739Z",
    stroke: "#7E8EAA",
    strokeWidth: 1.5,
    strokeMiterlimit: 23.3333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesfactures);
export default __webpack_public_path__ + "static/media/Mes factures.9b36136b26b23cd508cb5b388440f0d1.svg";
export { ForwardRef as ReactComponent };